import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ButtonToolbar, Col, Row } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import Can from 'modules/permissions/abilities/Can';
import Button from '../core/components/buttons/Button';
import Icon from '../core/components/Icon';
import VehiclePolicies from '../orders/components/fields/VehiclePolicies';

import * as vehicleActions from '../vehicles/store/actions';
import DataTable from '../core/components/datatable/DataTable';
import VehicleModal from '../orders/components/fields/VehicleModal';
import { dateTimeStringToUnix, unixToDateTimeString } from 'modules/core/utils/date';

// interface ClientVehiclesProps {
//   getClientVehicles?(...args: unknown[]): unknown
//   vehicles?: unknown[]
//   clientId?: string
//   clientIdClientVehicles?: string
//   user?: object
//   onlyShowInsurance?: boolean
// }

const ClientVehicles = props => {
  const {
    getClientVehicles,
    makeClientVehiclePrimary,
    vehicles,
    clientId,
    clientIdClientVehicles,
    // user,
    onlyShowInsurance = false,
  } = props;

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAddVehicle, setShowAddVehicle] = useState(false);
  const [vehicleId, setVehicleId] = useState(null);

  const getRowClassName = ({ row }) => {
    return row?.id === vehicleId ? 'pale-green-string' : '';
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadData = async (updateAnyway = false) => {
    if ((!(clientIdClientVehicles === clientId)) || (updateAnyway)) {
      setLoading(true);
      await getClientVehicles({ clientId, showDeleted: true });
      setLoading(false);
    }
  };

  const makePrimary = async (id) => {
    const y = vehicles.map(v => {
      return { ...v, primary: v.id === id };
    });
    await makeClientVehiclePrimary({ vehicleId: id, clientId, list: y });
  };

  const columns = [
    { title: 'Марка', name: 'makeTitle' },
    { title: 'Модель', name: 'modelTitle' },
    { title: 'Поколение', name: 'generationName' },
    { title: 'Номер', name: 'number' },
    { title: 'Актуальность', name: 'deletedDate', getCellValue: row => row.deletedDate && 'Удален' },
    {
      title: 'Дата добавления', name: 'createdDate', 
      getCellValue: (row, cell) => (row[cell] ? unixToDateTimeString(row[cell], 'DD.MM.YYYY HH:mm') : ''),
      sortValueConverter: (value) => (value ? dateTimeStringToUnix(value) : ''),      
    },
    {
      name: 'primary',
      title: 'Главный',
      getCellValue: row => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <Row
          onClick={ () => {
            if (!row.primary) {
              makePrimary(row.id);
            }
          } }
        >
          <Col className='dontRowClick'>
            <span className='dontRowClick'>{ row?.primary
              ? <Icon name='square-check' className='dontRowClick' />
              : <Icon name='square' className='dontRowClick' /> }
            </span>
          </Col>
        </Row>
      ),
      component: () => null,
      width: 185,
    },
  ];

  const columnsShort = [
    { title: 'Марка', name: 'makeTitle' },
    { title: 'Модель', name: 'modelTitle' },
    { title: 'Номер', name: 'number' },
    { title: 'VIN', name: 'vin' },
    {
      name: 'primary',
      title: 'Главный',
      getCellValue: row => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <Row
          onClick={ () => {
            if (!row.primary) {
              makePrimary(row.id);
            }
          } }
        >
          <Col className='dontRowClick'>
            <span className='dontRowClick'>{ row?.primary
              ? <Icon name='square-check' className='dontRowClick' />
              : <Icon name='square' className='dontRowClick' /> }
            </span>
          </Col>
        </Row>
      ),
      component: () => null,
      width: 185,
    },
  ];

  const handleRowClick = tableRow => {
    const vehicle = tableRow.row;
    setVehicleId(vehicle.id);
    if (!onlyShowInsurance) {
      if (isEmpty(vehicle.deletedDate)) {
        setShowModal(true);
      }
    };
  };

  const onChange = () => {
    loadData(true);
    setShowModal(false);
    setShowAddVehicle(false);
  };

  useEffect(() => {
    if (clientId) {
      loadData();
    }
  }, [clientId, vehicles, onlyShowInsurance, loadData]);

  return (
    <>
      { !onlyShowInsurance &&
      <Col md={ 12 }>
        <Row>
          <Col md={ 12 }>
            <Can do='permissionInsert' on='order.vehicle' passThrough>
              { can => (
                <ButtonToolbar className='float-end'>
                  <Button
                    text='Добавить авто'
                    icon='plus'
                    onClick={ () => setShowAddVehicle(true) }
                    variant='primary'
                    disabled={ !can || loading }
                  />
                </ButtonToolbar>
              ) }
            </Can>
          </Col>
        </Row>
      </Col> }
      <Col md={ 12 }>
        <Row>
          <Col md={ 12 }>
            { !(loading) && (clientId === clientIdClientVehicles) && (
              <DataTable
                loading={ loading }
                data={ vehicles }
                columns={ onlyShowInsurance ? columnsShort : columns }
                onRowClick={ handleRowClick }
                hidePagination
                hideToolbar
                rowClassName={ onlyShowInsurance ? getRowClassName : '' }
              />
            ) }
          </Col>
        </Row>
      </Col>
      { vehicleId && onlyShowInsurance && (
        <Col md={ 12 }>
          <VehiclePolicies
            vehicleId={ vehicleId }
            onlyShowInsurance = { onlyShowInsurance }
          />
        </Col>
      ) }

      <Can do='permissionUpdate' on='order.vehicle' passThrough>
        { can => (
          <VehicleModal
            show={ showModal }
            onHide={ () => setShowModal(false) }
            onReset={ () => setShowModal(false) }
            initialValues={ { number: '' } }
            clientId={ clientId }
            vehicleId={ vehicleId }
            onChange={ onChange }
            readOnly={ !can }
            clientMode={ true }
            lightMode={ false }
          />
        ) }
      </Can>
      <Can do='permissionInsert' on='order.vehicle'>
        { showAddVehicle && (
          <VehicleModal
            show={ true }
            onHide={ () => setShowAddVehicle(false) }
            onReset={ () => setShowAddVehicle(false) }
            onSubmit={ onChange }
            title='Добавление авто'
            initialValues={ { foreign: false, number: '' } }
            clientId={ clientId }
            // ref={ ref }
          />
        ) }
      </Can>
    </>
  );
};

const mapStateToProps = state => ({
  vehicles: state.vehicles?.clientVehicles,
  clientIdClientVehicles: state.vehicles?.clientIdClientVehicles,
  user: state.auth?.profile,
});

const mapDispatchToProps = dispatch => ({
  getClientVehicles: payload => dispatch(vehicleActions.getClientVehicles(payload)),
  makeClientVehiclePrimary: payload => dispatch(vehicleActions.makeClientVehiclePrimary(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientVehicles);
